module.exports = __webpack_public_path__ + "static/media/FifthContainerImage.a7e96085.webp";